import * as React from "react"

import { MD_BUTTON } from "@/shadcn/components/styles"
import { Button } from "@/shadcn/components/ui/button"

import { emptyState, panel } from "./copy"

/**
 * What the panel shows before its first run.
 *
 * Previously a title and a button in the corner with nothing between them, which
 * said neither what Medic looks at nor how long it takes.
 *
 * The run action sits in this block rather than only in the panel header: an empty
 * state's job is to explain and then prompt, and an action in the far corner makes
 * the reader travel back across the panel to act on what they have just read. The
 * header button stays for repeat runs once a report exists.
 *
 * Full width, matching the report cards that replace it, but the width is used by
 * the layout — prose held to a readable measure, action on a justified bottom row
 * — rather than by stretching a paragraph across the whole panel.
 */
export default function MedicEmptyState({
  onRun,
  busy = false,
}: {
  onRun?: () => void
  busy?: boolean
}) {
  return (
    <div className="tw:flex tw:flex-col tw:gap-4 tw:rounded-xl tw:border tw:border-dashed tw:border-border tw:px-4 tw:py-5">
      <div className="tw:flex tw:max-w-[62ch] tw:flex-col tw:gap-1.5">
        <h4 className="tw:text-base tw:leading-6 tw:font-medium tw:text-card-foreground">
          {emptyState.heading}
        </h4>
        <p className="tw:text-sm tw:leading-5 tw:text-muted-foreground">{emptyState.body}</p>
      </div>

      {onRun && (
        <div className="tw:flex tw:flex-col tw:items-start tw:gap-1.5">
          <Button type="button" className={MD_BUTTON} onClick={onRun} disabled={busy}>
            {busy ? panel.runBusy : panel.runIdle}
          </Button>
          {/* Under the control that starts the wait, so it reads as a note about
              pressing it rather than a label competing for the same line. */}
          <span className="tw:text-xs tw:leading-5 tw:text-muted-foreground">
            {emptyState.timing}
          </span>
        </div>
      )}
    </div>
  )
}
